<template>
  <section class="flow bg_white">
    <P class="flow_title ab">BC{{ subscriptionNowBC }}</P>
    <!-- step1~5に帰れば見た目も変わる -->
    <ul class="step" v-bind:class="{ 'step1': step == 1, 'step2': step == 2, 'step3': step == 3, 'step4': step == 4, 'step5': step == 5}" >
      <li>
        <p class="flow-num">1</p>
        <p class="flow-name">BC選択</p>
      </li>
      <li>
        <p class="flow-num">2</p>
        <p class="flow-name">商品選択</p>
      </li>
      <li>
        <p class="flow-num">3</p>
        <p class="flow-name">お支払情報・配送先</p>
      </li>
      <li>
        <p class="flow-num">4</p>
        <p class="flow-name">確認画面</p>
      </li>
      <li>
        <p class="flow-num">FINISH</p>
        <p class="flow-name hidden">FINISH</p>
      </li>
    </ul>
  </section>

</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: ['step'],
  computed: mapGetters(['subscriptionNowBC']),
}
</script>

<style lang="css" media="screen" scoped>
.flow_title {
  color: #1DB9B9;
  font-size: 14px;
  left: 0;
  line-height: 1;
  margin: auto;
  position: absolute;
  right: 0;
  top: 8px;
  text-align: center;
}

.step {
  margin-top: 5px;
}

.hidden{
  visibility: hidden;
}
/* デフォルト */
.hidden{
  visibility: hidden;
}
/* デフォルト */
.flow{
  padding: 64px 30px 17px;
  box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.1);
  position: relative;
}
.flow ul{
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 0;
}

.flow ul::before,
.flow ul::after{
  content: '';
  position: absolute;
  height: 2px;
  top: -21px;
  left: 0;

  margin: auto;
}
.flow ul::after{
  width: calc(100% - 10px);
  background-color: #C9C9C9;
  z-index: -2;
  right: 0;
  margin: auto;
}

.flow ul::before{
  background-color: #1DB9B9;
  z-index: -1;
}

.flow ul li{
  text-align: center;
  margin-right: 8%;
  position: relative;
}
.flow ul li:nth-of-type(2),
.flow ul li:nth-of-type(3) {
  margin-right: 2%;
}
.flow ul li:last-of-type {
  margin-right: 0;
}

.flow-num {
  align-items: center;
  background: #C9C9C9;
  border-radius: 100px;
  color: #fff;
  display: flex;
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 18px;
  height: 100vw;
  justify-content: center;
  left: 0;
  max-height: 33px;
  max-width: 33px;
  margin: auto;
  position: absolute;
  right: 0;
  top: -38px;
  width: 100vw;
}
.flow ul li:last-of-type .flow-num{
  font-size: 8px;
}
.flow-name {
  font-size: 8px;
  font-weight: bold;
  color: #C9C9C9;
  height: 15px;
}

/* step1付与時 */
.flow ul.step1 li:nth-of-type(1) .flow-num {
  background: #1DB9B9;
}
.flow ul.step1 li:nth-of-type(1) .flow-name {
  color: #1DB9B9;
}

/* step2付与時 */
.flow ul.step2 li:nth-of-type(-n+2) .flow-num {
  background: #1DB9B9;
}
.flow ul.step2 li:nth-of-type(-n+2) .flow-name {
  color: #1DB9B9;
}
.flow ul.step2::before{
  width: 25%;
}

/* step3付与時 */
.flow ul.step3 li:nth-of-type(-n+3) .flow-num {
  background: #1DB9B9;
}
.flow ul.step3 li:nth-of-type(-n+3) .flow-name {
  color: #1DB9B9;
}
.flow ul.step3::before{
  width: 50%;
}

/* step4付与時 */
.flow ul.step4 li:nth-of-type(-n+4) .flow-num {
  background: #1DB9B9;
}
.flow ul.step4 li:nth-of-type(-n+4) .flow-name {
  color: #1DB9B9;
}
.flow ul.step4::before{
  width: 75%
}

/* step5付与時 */
.flow ul.step5 li:nth-of-type(-n+5) .flow-num {
  background: #1DB9B9;
}
.flow ul.step5 li:nth-of-type(-n+5) .flow-name {
  color: #1DB9B9;
}
.flow ul.step5::before{
  width: 95%;
}

</style>



// WEBPACK FOOTER //
// src/components/subscription/Flow.vue